export default __webpack_public_path__ + "static/media/membrete.82be0f5c.png";